import React, { FC } from 'react';
import { GaugeSegmentProps } from 'types';

export const Segment: FC<GaugeSegmentProps> = ({ d, fill }) => (
	<path d={d} fill={fill} />
);

export default Segment;
